import React, { Component } from "react";
import { AuthenticationContext } from "react-adal";

export const authContext = new AuthenticationContext({
    tenant: "ca7621e7-a15f-4dc1-9515-5cbd8ac365b8",
    clientId: "33350e5b-87cb-458e-8216-720d2664ac08",
    endpoints: {
        api: "33350e5b-87cb-458e-8216-720d2664ac08",
    },
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    cacheLocation: "localStorage",
});

export const logout = (): void => {
    const isAdalLoging = authContext.getCachedUser();
    sessionStorage.clear();
    localStorage.clear();
    if (isAdalLoging) {
        const loginSite = "azuread";
        const baseUrl = window.location.origin.includes("localhost:")
            ? "http://localhost:3000"
            : window.location.origin;
        window.location.href =
            loginSite.toLowerCase() === "azuread"
                ? `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${baseUrl}`
                : "/login";
    } else {
        window.location.href = "/";
    }
};

interface AdalAuthState {
    isAuthenticated: boolean;
}

class AdalAuth extends Component<{}, AdalAuthState> {
    constructor(props: {}) {
        super(props);
        this.state = {
            isAuthenticated: !!authContext.getCachedUser(),
        };

    }

    isAuthenticated = (): boolean => {
        return !!authContext.getCachedUser();
    };

    decodeToken = (token: string): Record<string, unknown> | null => {
        try {
            const payload = token.split(".")[1];
            return JSON.parse(atob(payload));
        } catch (error) {
            console.error("Invalid token", error);
            return null;
        }
    };

    render() {
        return null;
    }
}

export default AdalAuth;
